import { render } from "./KeyboardSheet.vue?vue&type=template&id=a92873ee"
import script from "./KeyboardSheet.vue?vue&type=script&lang=js"
export * from "./KeyboardSheet.vue?vue&type=script&lang=js"

import "./KeyboardSheet.vue?vue&type=style&index=0&id=a92873ee&lang=scss"
script.render = render

export default script